import imageCard from "./imageCard"
export default imageCard;
